import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class Assets {
  /* 资产列表 */
  static getAssetLsit(currentPage, options) {
    let url = `/zzd/api/back/property/list/${currentPage}?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 资产导出 */
  static downloadAssetList(options) {
    let url = `/zzd/api/back/property/download?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 资产导入 */
  static assetImport(data) {
    let url = `/zzd/api/back/property/upload`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除资产 */
  static postDelAssets(data) {
    const url = `/zzd/api/back/property/delete`;
    return axios.post(url,data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 报废资产 */
  static postScrapAssets(data) {
    const url = `/zzd/api/back/property/give/up`;
    return axios.post(url,data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑资产 */
  static postModAssets(data) {
    const url = `/zzd/api/back/property/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 发起清查 */
  static postAssetsCheck(data) {
    const url = `/zzd/api/back/property/init/clear`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 坐落位置列表 */
  static getLocationList(name, groupId) {
    const url = `/zzd/api/back/location/list?name${name}&groupId=${groupId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增坐落位置 */
  static postAddLocation(data) {
    const url = `/zzd/api/back/location/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改坐落位置 */
  static postModLocation(data) {
    const url = `/zzd/api/back/location/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除坐落位置 */
  static postDelLocation(id) {
    const url = `/zzd/api/back/location/delete/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 审批记录列表 */
  static getApprovalRecordList(options) {
    let url = `/zzd/api/back/application/property/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 记录导出 */
  static getDownloadApprovalRecord(options) {
    let url = `/zzd/api/back/application/property/download?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 获取资产管理元下的3级部门 */
  static getRoleTypeThirdDepartment(roleType) {
    let url = `/zzd/api/back/dept/list/role/user/authority/dept?roleType=${roleType}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取当前用户作为某模块管理员的部门管理范围 */
  static getKeywordThirdDepartment(keyword) {
    let url = `/zzd/api/back/dept/list/sub/admin/authority/dept?keyword=${keyword}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }

  /* 流程列表 */
  static postProcedure(type) {
    const url = `/zzd/api/back/property/approve/setting/list?type=${type}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增流程 */
  static postAddProcedure(data) {
    const url = `/zzd/api/back/property/approve/setting/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改流程 */
  static postModProcedure(data) {
    const url = `/zzd/api/back/property/approve/setting/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除流程 */
  static postDelProcedure(data) {
    const url = `/zzd/api/back/property/approve/setting/delete`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改RFID编码 */
  static postModRFID(data) {
    const url = `/zzd/api/back/property/update/epc`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 资产出入记录列表 */
  static getInAndOutRecordList(currentPage, propertyId) {
    const url = `/zzd/api/back/property/list/epc/record?currentPage=${currentPage}&propertyId=${propertyId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 位置导入 */
  static placeImport(data) {
    let url = `/zzd/api/back/location/upload`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Assets